module.exports = __webpack_public_path__ + "static/MMsciIcon512-95059c2546b248dc60244216e260ca29.png";